export const environment = {
  production: true,
  oidc: {
    clientId: "0oa24592zu3dKvz1V0h8",
    issuer: "https://hcc-dev.oktapreview.com/oauth2/aus2f5p1r7rJQgYV80h8",
    pkse: false,
    redirectUri: "https://knrportal-qa.tmhcc.com/callback",
    scopes: ["openid", "email", "profile", "address", "phone", "offline_access", "rating"],
    testing: {
      disableHttpsCheck: false
    }
  },
  widget: {
    USE_CLASSIC_ENGINE: false
  },
};
